import { render, staticRenderFns } from "./IndustryList.vue?vue&type=template&id=0e53e1e8&scoped=true&"
import script from "./IndustryList.vue?vue&type=script&lang=js&"
export * from "./IndustryList.vue?vue&type=script&lang=js&"
import style0 from "./IndustryList.vue?vue&type=style&index=0&id=0e53e1e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e53e1e8",
  null
  
)

export default component.exports